import _ from 'lodash';
import {
    ARAG_USERS,
    SOLICITOR_USERS,
    ADMIN_USERS,
    AGENTS_USERS,
    COUNTRY,
    CANADA_COUNTRY,
    CURRENCY
} from './variables';
import accounting from 'accounting';
import moment from 'moment';

//function that gets as an input a date string and returns a valid html date string
export function getHtmlValidDate(date){
    let splitDate = date.split('/');
    let dd,mm,yyyy;
    mm= splitDate[1];
    dd = splitDate[0];
    yyyy = splitDate[2];
    if(parseInt(splitDate[0]) < 10){
        dd = '0' + parseInt(splitDate[0])
    }
    else {
        dd = splitDate[0];
    }
    if(parseInt(splitDate[1]) < 10){
        mm = '0' + parseInt(splitDate[1])
    }
    else {
        mm = splitDate[1];
    }
    return yyyy + '-' + mm + '-' + dd;
}
export function getValidDate(date){
    let dateParts = date.split("/");

    // month is 0-based, that's why we need dataParts[1] - 1
    let dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);

    return dateObject;
}
//function that checks if the input is a valid json string
export function IsJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}
//function that checks if logged in user is an arag user
export function isAragUser(loggedInUsersRoles) {
    let result = false;
    _.forEach(loggedInUsersRoles, role => {
        if(ARAG_USERS.includes(role)){
            result = true;
            return false;
        }
    });
    return result;
}
//function that checks if logged in user is an agent  user
export function isAgent(loggedInUsersRoles) {
    let result = false;
    _.forEach(loggedInUsersRoles, role => {
        if(AGENTS_USERS.includes(role)){
            result = true;
            return false;
        }
    });
    return result;
}
//function that checks if logged in user is a solicitor  user
export function isSolicitorUser(loggedInUsersRoles) {
    let result = false;
    _.forEach(loggedInUsersRoles, role => {
        if(SOLICITOR_USERS.includes(role)){
            result = true;
            return false;
        }
    });
    return result;
}
//function that checks if logged in user is an admin  user
export function isAdminUser(loggedInUsersRoles) {
    let result = false;
    _.forEach(loggedInUsersRoles, role => {
        if(ADMIN_USERS.includes(role)){
            result = true;
            return false;
        }
    });
    return result;
}
//function that checks if input is email
export function isEmail(input){
    let reguralExp = /^(\w|')+([\.-]?(\w|')+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/;
    try {
        if(input.match(reguralExp)){
            return true;
        }
        else{
            return false;
        }
    }
    catch (e) {
        return false;
    }
}
//function that checks if input is phone
export function isPhone(input){
    let reguralExp = COUNTRY == CANADA_COUNTRY ? /^(?:(\+?1-?)|001-?)?(\d{3}-?){2}\d{4}$/ : /^(\+44|0|0044)\d{10}$/im;
    try {
        if(input.match(reguralExp)){
            return true;
        }
        else{
            return false;
        }
    }
    catch (e) {
        return false;
    }
}

export function formatedMoney(limitOfIndemnity, currency){
   return accounting.formatMoney(limitOfIndemnity, `${currency} `, 2)
}

export const getLawsysArrayQueryParameter = (lawsys) => {
    try {
        return lawsys.reduce((current, next, index) => {
            const val = `lawsysIds=${next.value}`;
            if(index === 0){
                return val
            }
            return current + `&${val}`;
        }, '')
    } catch (e) {
        return '';
    }
};
export const getArrayQueryParameterMachineName = (queryString, params) => {
    try {
        return params.reduce((current, next, index) => {
            const val = `${queryString}=${next.machineName}`;
            if (index === 0) {
                return val
            }
            return current + `&${val}`;
        }, '')
    } catch (e) {
        return '';
    }
};
export const getSolicitorUsersArrayQueryParameter = (lawsys) => {
    try {
        return lawsys.reduce((current, next, index) => {
            const val = `solicitorUsersIds=${next.value}`;
            if(index === 0){
                return val
            }
            return current + `&${val}`;
        }, '')
    } catch (e) {
        return '';
    }
};
//constructs an array query param
export const getArrayPamaterer = (entity, queryString) => {
    try {
        return entity.reduce((current, next, index) => {
            const val = `${queryString}=${next.value}`;
            if(index === 0){
                return val
            }
            return current + `&${val}`;
        }, '')
    } catch (e) {
        return '';
    }
};
//checks if the entity is selected by matching its machine name with the given collection
export const isEntitySelected = (machineNameToMatch, selectedEntities) => {
    //each item of the entity collection must have a property machineName to match
    try {
        return !!selectedEntities.find(entity => entity.machineName === machineNameToMatch);
    } catch (e) {
        return false;
    }
};
export const actionCreator = (actionType) => (payload) => ({
   type: actionType,
   payload: payload
});
export const areEntitiesWithIdsEqual = (firstEntity, secondEntity) => {
    const totalMatches = firstEntity.reduce((accumulator, currentItem) => {
        if(secondEntity.find(item => item.id === currentItem.id)) {
            return accumulator + 1;
        }
        return accumulator;
    }, 0);
    return (totalMatches === secondEntity.length) && (totalMatches === firstEntity.length);
};
export const getArrayQueryParameter = (updateFormQuestions, parameterName) => {
    try {
        return updateFormQuestions.reduce((current, next, index) => {
            const val = `${parameterName}=${next.value}`;
            if (index === 0) {
                return val
            }
            return current + `&${val}`;
        }, '')
    } catch (e) {
        return '';
    }
};
export const scrollToElement = (element, options) => {
    if(options) {
        window.scrollTo(options);
    } else {
        window.scrollTo(0, element.offsetTop);
    }
};
export const errorParser = (e) => {
    try {
        if (
            e
            && e.body
            && e.body.message
        ) {
            return e.body.message;
        }

        if (
            e
            && e.body
            && e.body.Message
        ) {
            return e.body.Message;
        }

    } catch (e) {
        return null;
    }
};
export const readFileAsBase64Async = (file) => {
    return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            resolve(reader.result.substring(reader.result.indexOf("base64,") + 7));
        };

        reader.onerror = reject;
    });
}
export const getParameterByName = (name, url) => {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};
export const downLoadFile = (name, base64Encoding, fileExtension) => {
    const src = `data:application/binary;base64,${base64Encoding}`;
    const fileName = name;

    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        const byteCharacters = atob(base64Encoding);
        const byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/binary" });
        window.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
        const downloadLink = document.createElement("a");
        document.body.appendChild(downloadLink);
        downloadLink.href = src;
        downloadLink.download = fileName;
        downloadLink.click();
        document.body.removeChild(downloadLink);
    }
};
export const _getFileFromBase64 = (documentToDownload) => {
    downLoadFile(documentToDownload.name, documentToDownload.encodedFile, null);
};
// trims and replaces the new lines in the given string with semicolons
export const trimAndAddSemicolonsInsteadOfNewLines = (inputString, question) => {
    let output = inputString;
    if(!output) {
        return output
    }

    // if question is of type calendar remove semicolons
    // if(question && question.inputType === "calendar"){
    //     return  output.replace(/;/gi, "");
    // }

    // if last character is not semicolon, then add one at the end
    if(output.length > 0 && output[output.length - 1] !== ";" && output[output.length - 1] !== "\n"){
        // output = output + ";" ;
    }

    //  replace new lines with semicolons and remove whitespaces
    return output.replace(/\n/gi, ";");
};
export const getSortableColumnSortClass = (orderBy, orderAsc, property) => {
    if (orderBy !== property) {
        return ""
    }

    if (orderAsc) {
        return "sort-desc";
    }

    return "sort-asc";
};
//function return a specific value of an array of object
export const extractSpecificElementOfArray=(array,nestedArray,element)=>{
    let helperFunction = [];
    _.forEach(array, i => {
        _.forEach(i[nestedArray], s => {
            helperFunction.push({
                [element]: s[element]
            });
        })
    });
    return {
        helperFunction: helperFunction,
    }
}
export const fileToObjectHandle = async (file) => {
    return new Promise((resolve, reject) => {
        let fileReader = new FileReader();
        fileReader.onload = () => {
            resolve({
                name: file.name,
                encodedFile: fileReader.result.substring(fileReader.result.indexOf("base64,") + 7),
                fileType: file.type
            });
        };
        fileReader.onerror = reject;
        fileReader.readAsDataURL(file);
    });
}
export const stringToNumber = (stringParam) =>{
    if(isNaN(stringParam) == true || stringParam === '')
    return 0;
    
    return parseFloat(stringParam);
    
}
export const amountColumnsDisplayDataPerStage = (stage) => {

    const commissionsAgentsData = stage.stagedPremiumSubSettingCommissionDtos.map(a =>
      ({ title: a.lawsysName, value: `${'$'}${stringToNumber(a.commissionPercentage) * 0.01 * stringToNumber(stage.premiumAmount)}`, isPlain: true, onChange: () => null }))
    return [
      {
        title: 'Premium', value: stage.premiumAmount, isPlain: false, onChange: (e) => null
      },
      {
        title: 'Limit of Indemnity', value: stage.limitOfIndemnity, isPlain: false, onChange: (e) =>null
      },
      { title: 'Underwriter rate', value: stringToNumber(stage.underwriterRatePercentage) * 0.01 * stringToNumber(stage.premiumAmount), isPlain: true, onChange: () => null },
      ...commissionsAgentsData
    ]
  }

  // validate amounts
export const validateAmount = (value, minimum) => {
    let errMsg = '';
    let s = value.toString().split(/\.|,/);
    try {
        if (s[0].length > 15) {
            errMsg = 'Value must be less than or equal to 999,999,999,999,999.99';
        } else if (s[1]?.length > 2) { // Using optional chaining to check for decimals
            errMsg = 'Number input should have at most 2 decimals';
        }
    } catch (e) {}

    if (isNaN(value) && value !== "") {
        errMsg = 'Input is not a valid number';
    }

    if (minimum && minimum !== null) {
        try {
            const minValueNumber = parseFloat(minimum);
            const valueNumber = parseFloat(value);
            if (valueNumber < minValueNumber) {
                errMsg = `Minimum value is ${CURRENCY}${minValueNumber.toString()}`;
            }
        } catch (e) {}
    }
    return errMsg;
};

export const formatNumber = (value) => {
    if (!value) return '0';
    const num = parseFloat(value);
    const valueString = value.toString();

    if (Number.isInteger(num)) {
        return num.toString();
    } else {           
        return num.toFixed(2);
    }
};
export const _getQuestionAnswer = (answer) => {
    if(answer.optionId) return answer.optionName;
    if(answer.text) return answer.text;
    if(answer.amount) return accounting.formatMoney(answer.amount, `${CURRENCY} `, 2);
    if(answer.date) return moment(answer.date).format('DD/MM/YYYY');
    if(answer.answerAttachments) return answer.answerAttachments.map(a =>a.name).join(", ");
    return '';
};

export const reduceAnswers = (questionsWithAnswers) => {
    const reducedAnswers = questionsWithAnswers.reduce((acc, item) => {
        acc[item.questionMachineName] = _getQuestionAnswer(item);
        return acc;
    }, {});
    return reducedAnswers;
}